export function Loader () {
    return (
        <div className="loader">
            <div className="lds-hourglass"></div>
        </div>
    )
}